/**
 * Listed prices, or prices after each venue's taker fee — the viewer's choice, persisted per
 * browser. The whole board re-ranks on it: the best listed price and the best price you can
 * actually take are often different venues.
 */
import { useSyncExternalStore } from "react";
import type { PriceMode } from "./board";

const KEY = "omodds.priceMode";

function read(): PriceMode {
  try {
    return localStorage.getItem(KEY) === "taker" ? "taker" : "listed";
  } catch {
    return "listed";
  }
}

let current: PriceMode = typeof window === "undefined" ? "listed" : read();
const listeners = new Set<() => void>();

export function setPriceMode(next: PriceMode): void {
  current = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // Storage blocked: the choice still holds for this visit.
  }
  for (const l of listeners) l();
}

export function usePriceMode(): PriceMode {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => {
        listeners.delete(cb);
      };
    },
    () => current,
    () => "listed",
  );
}
